import { toast } from "react-toastify";

// Definim funcțiile pentru toast-uri și le exportăm împreună
const ToastService = {
  showSuccess(message: string) {
    toast.success(message, {
      position: "top-right",
      autoClose: 5000,
    });
  },

  showError(message: string) {
    toast.error(message, {
      position: "top-right",
      autoClose: 5000,
    });
  },

  showInfo(message: string) {
    toast.info(message, {
      position: "top-right",
      autoClose: 5000,
    });
  },
};

export default ToastService;
